import { yupResolver } from '@hookform/resolvers/yup';
import { Grid } from '@mui/material';
import { SGSFormLayout } from 'components';
import { useArretTravailFormContext } from 'features/arretTravail/contexts/ArretTravailFormProvider';
import useValidationEffects from 'features/arretTravail/hooks/useValidationEffects';
import { useEffect } from 'react';
import { FormProvider, SubmitHandler, useFieldArray, useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { useSalaryRappelSchema } from './schema';
import { TableSalaryRappel } from './table';

type Props = {
    store: any;
    onSubmit: SubmitHandler<SalaireRappelS6202Schema>;
    actions?: JSX.Element;
};

export type ISalaireRappelS6202 = {
    id: string;
    paymentDate: Date | null;
    startDate: Date | null;
    endDate: Date | null;
    amount: string;
    cotisation: string;
};

type SalaireRappelS6202Schema = {
    salaryRappelS6202: {
        salaries: ISalaireRappelS6202[];
    };
};

const FormSalaryRappelS6202: React.FC<Props> = ({ onSubmit, store, actions }) => {
    const { activeStep, setStepFailed } = useArretTravailFormContext();
    const validationSchema: Yup.SchemaOf<SalaireRappelS6202Schema> = useSalaryRappelSchema();

    const nbrMonth = 1;
    const initialSalaires = Array.from({ length: nbrMonth }, (_, index) => {
        return {
            id: `${index + 1}`,
            paymentDate: null,
            startDate: null,
            endDate: null,
            amount: null,
            cotisation: null,
        };
    });

    const methods = useForm<SalaireRappelS6202Schema>({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            ...store,
            salaryRappelS6202: {
                salaries: store?.salaryRappelS6202?.salaries.length ? store.salaryRappelS6202.salaries : initialSalaires,
            },
        },
    });

    const {
        handleSubmit,
        control,
        formState: { errors },
    } = methods;

    useValidationEffects({ errors, activeStep, setStepFailed, control });

    const {
        fields: salaries,
        append: appendSalary,
        remove: removeSalary,
    } = useFieldArray<SalaireRappelS6202Schema, 'salaryRappelS6202.salaries', 'id'>({
        control,
        name: 'salaryRappelS6202.salaries',
        keyName: 'id',
    });

    const handleNewSalaire = () => {
        appendSalary({
            id: `${salaries.length + 1}`,
            paymentDate: null,
            startDate: null,
            endDate: null,
            amount: null,
            cotisation: null,
        });
    };

    useEffect(() => {
        if (salaries.length === 0) handleNewSalaire();
    }, [salaries]);

    console.log(errors);

    return (
        <FormProvider {...methods}>
            <SGSFormLayout onSubmit={handleSubmit(onSubmit)} actions={actions}>
                <Grid container justifyContent="center" style={{ marginBottom: '20px' }}>
                    <Grid item xs={12} md={12}>
                        <TableSalaryRappel salaries={salaries} appendSalary={handleNewSalaire} removeSalary={removeSalary} />
                    </Grid>
                </Grid>
            </SGSFormLayout>
        </FormProvider>
    );
};

export default FormSalaryRappelS6202;
